import { useQuery } from '@tanstack/react-query';
import statisticsService from '../services/statisticsService';

export const useGetMonthlySalesByYear = (year: string) => {
	return useQuery({
		queryKey: ['monthlySales', year],
		queryFn: () => statisticsService.getMonthlySales(year),
	});
};

export const useGetMonthlyApprovedAccountsByYear = (year: string) => {
	return useQuery({
		queryKey: ['monthlyNewAccounts', year],
		queryFn: () => statisticsService.getMonthlyApprovedAccounts(year),
	});
};

export const useGetMonthlyCreditsSpentByYear = (year: string) => {
	return useQuery({
		queryKey: ['monthlyCreditsSpent', year],
		queryFn: () => statisticsService.getMonthlyCreditsSpent(year),
	});
};

export const useGetMonthlyMessagesSentByYear = (year: string) => {
	return useQuery({
		queryKey: ['monthlyMessagesSent', year],
		queryFn: () => statisticsService.getMonthlyMessagesSent(year),
	});
};
